<template>
  <div>
    <headBar />
    <div v-scroll-spy>
      <!-- hero section start -->
      <section class="section hero-section bg-ico-hero" id="home">
        <div class="bg-overlay bg-fica"></div>
      </section>

      <div class="container">


      </div>

      <div style="height: 100vh;">
        <iframe
                :src="getURl()"
                width="100%" height="100%"
                frameborder="0"
                marginheight="0"
                marginwidth="0">Cargando…</iframe>
      </div>



      <!-- Footer start -->
      <footer class="landing-footer">
        <div class="container">

          <!-- end row -->

          <hr class="footer-border my-5" />

          <div class="row">
            <div class="col-lg-6">
              <div class="mb-4">
                <img src="@/assets/images/logo-light2.png" alt height="20" />
              </div>
              <p
                class="mb-2"
              >{{ new Date().getFullYear() }} © FGlobal. </p>
              <p>-----------</p>
            </div>
          </div>

        </div>
        <!-- end container -->
      </footer>
      <!-- Footer end -->
    </div>
  </div>
</template>
<script>
  //import { Carousel, Slide } from "vue-carousel";

  import  headBar from '@/components/head-bar';
  /**
   * Crypto ICO-landing page
   */

  export default {

    created() {
      window.addEventListener("scroll", this.windowScroll);

    },
    destroyed() {
      window.removeEventListener("scroll", this.windowScroll);
    },
    beforeMount() {

    },
    mounted() {

    },
    components: {  headBar},
    data() {
      return {

        model:{
          tipo:{
            permitir_subir_archivos:0
          }
        },
        token:'',
        codigo_matricula:'',
        isLoading:false

      };
    },


    methods: {
      getURl(){
        if(this.$route.params.form_id!=undefined)
        {
          var url;
          url="https://docs.google.com/forms/d/"+this.$route.params.form_id+"/viewform?embedded=true";
          console.log(url);
          return url;
        }
        else
        {
          alert("No existe el parametro");
        }

      },
      windowScroll() {
        const navbar = document.getElementById("navbar");
        if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky");
        } else {
          navbar.classList.remove("nav-sticky");
        }
      },

    }
  };
</script>
<style>
  .big-font{
    font-size: 14px !important;
    color: #000000;

  }
  .g-recaptcha {
    transform:scale(0.88);
    transform-origin:0 0;
  }


</style>
